import React from "react";

import cx from "classnames";

import styles from "./Checkbox.module.css";

type InputProps = React.HTMLProps<HTMLInputElement> &
	React.InputHTMLAttributes<HTMLInputElement> & { innerRef?: React.Ref<HTMLInputElement> };
export type CheckboxProps = Pick<InputProps, Exclude<keyof InputProps, "type">> & {
	green?: boolean;
	royal?: boolean;
	/** Because `onChange` is annoying */
	onCheckedChange?(checked: boolean): void;
};

/** @deprecated Use ~/ui/checkbox instead.
 * @link https://ui.corp.fellow.co/?path=/docs/components-checkbox--docs
 */
export default class Checkbox extends React.PureComponent<CheckboxProps> {
	onChange: React.ChangeEventHandler<HTMLInputElement> = e => {
		this.props.onChange?.(e);
		this.props.onCheckedChange?.(e.currentTarget.checked);
	};
	render() {
		const { className, green, royal, innerRef, onChange: _onChange, ...rest } = this.props;
		return (
			<input
				ref={innerRef}
				type="checkbox"
				onChange={this.onChange}
				{...rest}
				className={cx(styles.checkbox, className, { [styles.green]: green, [styles.royal]: royal })}
			/>
		);
	}
}
